const CompanysSang = [
    {ID: -1 , Name : "همه موارد" , CompanyCategoryId: [1001 , 1002]},
    {ID: 1 , Name : "تراورتن ابرکوه" , CompanyCategoryId: [1001]},
    {ID: 2 , Name : "تراورتن ابیانه" , CompanyCategoryId: [1001]},
    {ID: 3 , Name : "تراورتن تکاب" , CompanyCategoryId: [1001]},
    {ID: 4 , Name : "تراورتن حاجی آباد" , CompanyCategoryId: [1001]},
    {ID: 5 , Name : "تراورتن دره بخاری" , CompanyCategoryId: [1001]},
    {ID: 6 , Name : "تراورتن رامشه" , CompanyCategoryId: [1001]},
    {ID: 7 , Name : "عباس آباد" , CompanyCategoryId: [1001]},
    {ID: 8 , Name : "کاشان" , CompanyCategoryId: [1001]},
    {ID: 9 , Name : "محلات" , CompanyCategoryId: [1001 , 1002]},
    {ID: 10 , Name : "یزد" , CompanyCategoryId: [1001 , 1002]},
    {ID: 11 , Name : "مرمریت آباده" , CompanyCategoryId: [1002]},
    {ID: 12 , Name : "مرمریت صلصالی" , CompanyCategoryId: [1002]},
    {ID: 13 , Name : "مرمریت لاشتر" , CompanyCategoryId: [1002]},
    {ID: 14 , Name : "هرسین" , CompanyCategoryId: [1002]},
]
export default CompanysSang